// Welches Ding einer Seite gerade aufgeklappt ist (docs/shell.md).
//
// Der Baum führt zur Seite: ein Klick auf eine Aufgabe, einen Pool oder
// eine Platte klappt dort die Zeile auf (?focus=, ?pool=, ?disk=). Das hier
// ist die Gegenrichtung (Tim 04.10.2026: „Wird ein Node erweitert, sollte
// im Baum auch das Element markiert sein"): die Seite meldet, was bei ihr
// offen steht, und der Baum markiert genau diese Zeile statt der Seite.
//
// Bei den Rechnern trägt das der Pfad des Tabs (/infra/cluster/<rechner>,
// setzePfadDerSeite). Aufgaben, Pools und Platten haben keinen eigenen
// Pfad -- ihr Verweis ist ein Parameter, den die Seite nach dem Aufklappen
// aus der Adresse nimmt. Darum ein eigener kleiner Stand je Seite.
//
// Schlüssel ist der Pfad der Seite ("/system/tasks"); der Wert ist die ID,
// unter der der Baum das Ding führt, ohne Präfix-Zwang -- Seite und Baum
// müssen sich nur einig sein (dingId unten).
import { untrack } from "svelte";
import { SvelteMap } from "svelte/reactivity";

const stand = new SvelteMap<string, string>();

/** Von der Seite gerufen, wenn sie eine Zeile auf- oder zuklappt. Beim
 *  Abbau der Seite mit null -- ein geschlossener Tab hat nichts offen. */
export function meldeOffenesDing(seite: string, ding: string | null): void {
  // untrack: die Seite ruft das aus einem $effect. Ohne das hinge der
  // Effekt an dem Stand, den er selbst schreibt.
  untrack(() => {
    if (ding) {
      if (stand.get(seite) !== ding) stand.set(seite, ding);
    } else if (stand.has(seite)) {
      stand.delete(seite);
    }
  });
}

/** Vom Baum gelesen. */
export function offenesDing(seite: string): string | undefined {
  return stand.get(seite);
}

/** Die IDs, auf die sich Seite und Baum einigen. */
export const dingId = {
  aufgabe: (id: string) => `task:${id}`,
  pool: (host: string, name: string) => `pool:${host}/${name}`,
  platte: (host: string, name: string) => `disk:${host}/${name}`,
};
